module.exports = __webpack_public_path__ + "static/media/Circle_of_Influence_Concern_Arrow_In.17cc8a0e.png";